import { Model } from '@nozbe/watermelondb';
import { text, date } from '@nozbe/watermelondb/decorators';

export default class Setting extends Model {
    static table = 'setting';

    @text('key') key;
    @text('value') value;
    @date('updated_at') updatedAt;
}